import { CalendarDays, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import type { EventSummary } from '@/lib/api/models';
import { formatDateTime } from '@/lib/utils/format';

export function EventCard({ event }: { event: EventSummary }) {
  return (
    <Card className="flex flex-col p-5 transition-shadow hover:shadow-[var(--shadow-elevated)]">
      <h3 className="text-lg font-bold text-ink">
        <Link to={`/events/${event.id}`} className="hover:text-purple-600">
          {event.title}
        </Link>
      </h3>
      <dl className="mt-3 space-y-1.5 text-sm text-muted">
        <div className="flex items-center gap-2">
          <CalendarDays className="h-4 w-4 text-teal-500" aria-hidden />
          <dd>{formatDateTime(event.start_at)}</dd>
        </div>
        {event.location && (
          <div className="flex items-center gap-2">
            <MapPin className="h-4 w-4 text-pink-500" aria-hidden />
            <dd>{event.location}</dd>
          </div>
        )}
      </dl>
      <Link
        to={`/events/${event.id}`}
        className="mt-4 inline-flex text-sm font-semibold text-teal-600 hover:text-teal-700"
      >
        View details & register →
      </Link>
    </Card>
  );
}
